import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-98" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-99" data-mp="et620re6wxz4">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-slate-400/30 bg-slate-800 p-8 shadow-lg shadow-black/30 sm:p-12" data-id="element-100" data-mp="euqxcj8bwky1">
          <span className="inline-flex rounded-full metal p-4 text-slate-950" data-id="element-101" data-mp="xjntytr77pjf">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-102" data-mp="xlrvx65jeeh2" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-103" data-mp="12gxim76rjx67">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-slate-300" data-id="element-104" data-mp="25sgitgp7wc1x">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            industrial maintenance class this week. If you feel your students didn't respond better or the materials didn't save you
            hours of work:
          </p>
          <p className="mt-6 rounded-lg border border-slate-400/20 bg-slate-900 px-5 py-4 text-lg font-extrabold text-white" data-id="element-105" data-mp="1rtyvvl74z3l2">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-106" data-mp="2eslpfoml76f1">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}